import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { AuthUser } from '@/api/istaff/auth';
import type { AuthState } from './types';

const initialState: AuthState = {
  accessToken: localStorage.getItem('access_token'),
  refreshToken: localStorage.getItem('refresh_token'),
  user: null,
  loginError: null,
  isLoggingIn: false,
  isResolved: !localStorage.getItem('access_token'),
  registerError: null,
  registerSuccess: false,
  devVerificationDetails: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (
      state,
      {
        payload,
      }: PayloadAction<{
        accessToken: string;
        refreshToken: string;
        user: AuthUser;
      }>,
    ) => {
      state.accessToken = payload.accessToken;
      state.refreshToken = payload.refreshToken;
      state.user = payload.user;
      state.loginError = null;
      state.isLoggingIn = false;
      state.isResolved = true;
    },
    setUser: (state, { payload }: PayloadAction<AuthUser>) => {
      state.user = payload;
      state.loginError = null;
      state.isResolved = true;
    },
    setLoginPending: (state) => {
      state.isLoggingIn = true;
    },
    setLoginError: (state, { payload }: PayloadAction<string>) => {
      state.loginError = payload;
      state.isLoggingIn = false;
      state.isResolved = true;
    },
    clearAuth: (state) => {
      state.accessToken = null;
      state.refreshToken = null;
      state.user = null;
      state.loginError = null;
      state.isLoggingIn = false;
      state.isResolved = true;
    },
    setRegisterSuccess: (
      state,
      { payload }: PayloadAction<{ user_id: number; hash: string } | undefined>,
    ) => {
      state.registerSuccess = true;
      state.registerError = null;
      state.devVerificationDetails = payload ?? null;
    },
    setRegisterError: (state, { payload }: PayloadAction<string>) => {
      state.registerError = payload;
      state.registerSuccess = false;
    },
    clearRegisterState: (state) => {
      state.registerError = null;
      state.registerSuccess = false;
      state.devVerificationDetails = null;
    },
  },
});

export const { reducer: authReducer } = authSlice;
export const { setRegisterSuccess, setRegisterError, clearRegisterState } =
  authSlice.actions;
